import React, {useEffect, useState, useMemo } from 'react'
import "../App.css"
import { UserProvider } from '../contexts/UserContext';
import { CssEditorProvider } from '../contexts/CssEditorContext';
import IsUser from '../components/IsUser';
import { getCss } from '../services/userServices';
import config from '../config';

export default function UserMiddleware() {
  const [loadedCss, setLoadedCss] = useState(null);
  const [appConfig, setAppConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const Control = async () => {
      try {
        // CSS ve app-config'i paralel olarak yükle
        const [cssResponse, configResponse] = await Promise.all([
          getCss(),
          fetch('/app-config.json').then(res => res.json()).catch(err => {
            console.warn('app-config.json yüklenemedi, fallback kullanılıyor:', err);
            return { domain: config.domain, key: config.key };
          })
        ]);

        // CSS yükle
        if (cssResponse && typeof cssResponse === 'object' && Object.keys(cssResponse).length > 0) {
          setLoadedCss(cssResponse.data);
        } else {
          console.warn('No saved CSS settings found or unexpected response format in Middleware.', cssResponse);
        }

        // App config yükle
        setAppConfig(configResponse);
        console.log('App Config yüklendi:', configResponse);
        
      } catch (error) {
        console.error('Config yükleme hatası:', error);
        // Fallback config
        setAppConfig({ domain: config.domain, key: config.key });
      } finally {
        setIsLoading(false);
      }
    }
    Control();
  },[]);

  // IsUser component'ini sadece bir kez render et
  const isUserComponent = useMemo(() => <IsUser />, []);

  // Loading state
  if (isLoading) {
    return (
      <div className="App">
        <div className='general-container'>
          <div style={{ color: '#fff', padding: '20px', textAlign: 'center' }}>
            Yükleniyor...
          </div>
        </div>
      </div>
    );
  }

  return (
    <CssEditorProvider initialCss={loadedCss}>
      <UserProvider appConfig={appConfig}>
        <div className="App">
          <div className='general-container'>
            {isUserComponent}
          </div>
        </div>
      </UserProvider>
    </CssEditorProvider>
  )
}
